<template>
  <div class="player-props-markets coupon" v-if="markets && markets.length">
    <div class="player-props-group" v-for="(group, name) in groups">
      <h4 class="event-market-header date">
        <span class="market-name" :class="{'expanded-market': groupsExpandedState[name]}" @click="toggle(name)">
          <span class="market-name-title">{{ name }}</span>
          <span class="flex icon-span">
            <v-icon v-if="!groupsExpandedState[name]">expand_more</v-icon>
            <v-icon v-if="groupsExpandedState[name]">expand_less</v-icon>
          </span>
        </span>
        <span class="market-name markets-title" v-if="groupsExpandedState[name]">
          <h4 class="over">Over</h4>
          <h4 class="under">Under</h4>
        </span>
      </h4>
      <markets
        v-if="groupsExpandedState[name]"
        :markets="group"
        :event="event"
        :diplayOnPage="'live-single-event'"
        :isLiveEventPage="isLiveEventPage"
        :pricechangehighlight="isLiveEventPage">
      </markets>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import lodash from 'lodash'

  import markets from '@/components/sports/bettingoffer/markets'
  import BettingOffer from '@/components/mixins/BettingOffer'

  export default {
    name: 'PlayerPropsMarkets',

    components: {
      markets
    },

    mixins: [
      BettingOffer
    ],

    props: [
      'markets',
      'event',
      'diplayOnPage',
      'isLiveEventPage',
      'pricechangehighlight',
      'expandFirst'
    ],

    data () {
      return {
        groupsExpandedState: {}
      }
    },

    computed: {
      groups () {
        let propsGroups = {}
        this.markets
          .forEach(mk => {
            let marketNameSegments = mk.name.split(' - ')
            let groupName = marketNameSegments.pop().trim()

            // If group doesn't exist in groupsExpandedState add it as collapsed
            if (!this.groupsExpandedState[groupName]) {
              Vue.set(this.groupsExpandedState, groupName, false)
            }

            // If group doesnt exist create it
            if (this.isPlayerPropsMarket(mk) && mk.selections && mk.selections.length) {
              if (!propsGroups[groupName]) {
                propsGroups[groupName] = []
              }
              // Add market to group
              mk.selections.forEach((sel) => {
                sel.name = marketNameSegments.join(' ')
              })
              propsGroups[groupName].push(mk)
            }
          })

        return propsGroups
      }
    },

    methods: {
      toggle (name) {
        Vue.set(this.groupsExpandedState, name, !this.groupsExpandedState[name])
      }
    },

    created () {
    },

    mounted () {
      // If there are no markets than Player Props market then collapse the first one
      if (this.expandFirst && !lodash.isEmpty(this.groupsExpandedState)) {
        Vue.set(this.groupsExpandedState, Object.keys(this.groupsExpandedState)[0], true)
      }
    },

    destroyed () {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/PlayerPropsMarkets.vue